<template>
  <v-generic-input
    :id="id"
    :required="required"
    :errors="errors"
  >
    <template v-slot:input>
      <label>
        <input
          :id="id"
          v-model="inputVal"
          type="checkbox"
          :placeholder="$t(placeholder)"
          :required="required"
          :disabled="disabled"
          class="mr-2"
        />

        <span v-if="translateText">
          {{ $tc(label, labelCount) }}<span class="text-muted" v-if="required">*</span>
        </span>
        <span v-else>{{ label }}<span class="text-muted" v-if="required">*</span></span>

        <span class="text-sm-left text-muted" v-if="helpText">
          <br /><small>{{ $tc(helpText) }}</small>
        </span>
      </label>
    </template>
  </v-generic-input>
</template>

<script>
import { GenericInputMixin } from '@/common/utils/mixins';
import _GenericInput from './_GenericInput.vue';

export default {
  name: 'CheckBox',
  components: {
    'v-generic-input': _GenericInput,
  },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    value: {
      type: Boolean,
    },
  },
  mixins: [
    GenericInputMixin,
  ],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.givenId = this.id || this._uid;
  },
};
</script>
